module.exports = __webpack_public_path__ + "static/media/customer.31cfa996.svg";